import {message} from 'antd';
import {useQueryClient} from '@tanstack/react-query';
import {directoryService} from '../services/directory';
import type {PermissionCheckParams} from '../types/directory';

export function usePermissionCheck(
  parentId: number | string,
  currentUser?: any
) {
  const queryClient = useQueryClient();

  async function check(items: PermissionCheckParams[]) {
    const result = await directoryService.checkPermission({
      items
    });

    const invalidItem = result.find((item: any) => {
      if (currentUser?.is_admin) {
        return false;
      }

      if (Number(item.owner_id) === Number(currentUser?.user_id)) {
        return false;
      }

      return item.visibility !== 'edit';
    });

    if (!invalidItem) {
      return true;
    }

    message.warning('文件权限已变更，正在更新列表');

    await queryClient.invalidateQueries({
      queryKey: ['file-list', parentId],
    });

    return false;
  }

  return {
    check
  };
}